// extracted by mini-css-extract-plugin
module.exports = {"text":"textSection_text__CdkKq","textSmall":"textSection_textSmall__2gJiW","textMedium":"textSection_textMedium__3FLh5","textLarge":"textSection_textLarge__39ZFv"};
    if(module.hot) {
      // 1783592037566
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  